import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { imageBaseApi, offshoreUrl, onshoreUrl } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import DashboardMenuService from "../../../services/KangarooServices/Intelligence/DashboardMenuService";
import toast from "react-hot-toast";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";
import { RiFileCopyLine } from "react-icons/ri";

const ProductService = () => {
  const navigate = useNavigate();

  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const authUser = getLoggedInUser();

  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");
  const isOffshoreAdmin = authUser.roles.includes("OffshoreAdmin");

  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await DashboardMenuService.getList();

      let filteredData = response;

      if (!isSuperAdmin) {
        if (isOnshoreAdmin) {
          filteredData = response.filter(
            (item) => item.isOnshoreIntelMenu === true,
          );
        } else if (isOffshoreAdmin) {
          filteredData = response.filter(
            (item) => item.isOnshoreIntelMenu === false,
          );
        }
      }

      setData(filteredData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await DashboardMenuService.delete(selectedDeleteItem.id);
        fetchData();
        toast.success("Selected item deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  const handleCopy = async (previewUrl) => {
    try {
      await navigator.clipboard.writeText(previewUrl);
      toast.success("Link copied to clipboard!");
    } catch (err) {
      toast.error("Failed to copy link");
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Products And Services"
          pageTitle="Content Management"
        />

        <Row className="mb-3">
          <div className="d-flex justify-content-between align-items-center ">
            <button
              className="btn btn-success"
              onClick={() => navigate("/product-service/create")}
            >
              <i className="bi bi-plus-lg"></i> New Menu
            </button>
          </div>{" "}
        </Row>

        <Row xs="1" md="2" lg="4" className="g-3">
          {data?.map((item) => {
            return (
              <Col key={item.id}>
                <Card className="h-100 shadow-sm border-0 rounded-4 small-card">
                  {/* Logo Section */}
                  <div className="logo-wrapper">
                    <CardImg
                      src={`${imageBaseApi}${item?.logoImage?.url}`}
                      alt={item?.fileName}
                      className="img-fluid w-100 h-100 object-fit-cover"
                    />
                  </div>

                  <CardBody className="py-2 px-3">
                    <h6 className="mb-1 fw-semibold text-truncate">
                      {item?.name}
                    </h6>

                    {/* <div className="d-flex align-items-center gap-2 text-muted small text-truncate cursor-pointer mb-2">
                      <i className="ri-links-line "></i>
                      <span
                        className="text-truncate"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCopy(item?.isOnshoreIntelMenu ? onshoreUrl + item?.url : offshoreUrl + item?.url);
                        }}
                      >
                        {item?.url}asd
                      </span>
                    </div> */}
                    <Badge
                      pill
                      color={item?.isOnshoreIntelMenu ? "success" : "danger"}
                      className="px-3 py-2"
                    >
                      {item?.isOnshoreIntelMenu ? "Onshore" : "Offshore"}
                    </Badge>
                  </CardBody>

                  <CardFooter className="bg-transparent border-0 pt-0 pb-3 px-3 d-flex justify-content-between align-content-center align-items-center">
                    <Button
                      size="sm"
                      color="light"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCopy(item?.isOnshoreIntelMenu ? onshoreUrl + item?.url : offshoreUrl + item?.url);
                      }}
                      className="d-flex align-items-center gap-1"
                      title="Copy Url"
                    >
                      <RiFileCopyLine size={16} />
                    </Button>
                    <div className="d-flex justify-content-end gap-2">
                      <a
                        href={item?.isOnshoreIntelMenu ? onshoreUrl + item?.url : offshoreUrl + item?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <button
                          className="btn btn-sm btn-info"
                          title="Preview"
                        >
                          <i className="ri-eye-line"></i>
                        </button>
                      </a>

                      <Button
                        size="sm"
                        color="warning"
                        onClick={() =>
                          navigate(`/product-service/update/${item?.id}`)
                        }
                      >
                        <i className="ri-pencil-line "></i>
                      </Button>

                      <Button
                        size="sm"
                        color="danger"
                        onClick={() => handleDeleteClick(item)}
                      >
                        <i className="ri-delete-bin-6-line "></i>
                      </Button>
                    </div>
                  </CardFooter>
                </Card>
              </Col>
            );
          })}
        </Row>

        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default ProductService;
